/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface LockCardForPotentialFraudRequestOneOf1
 */
export interface LockCardForPotentialFraudRequestOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof LockCardForPotentialFraudRequestOneOf1
     */
    'lockType': LockCardForPotentialFraudRequestOneOf1LockTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LockCardForPotentialFraudRequestOneOf1
     */
    'description': string;
}

export const LockCardForPotentialFraudRequestOneOf1LockTypeEnum = {
    other: 'OTHER'
} as const;

export type LockCardForPotentialFraudRequestOneOf1LockTypeEnum = typeof LockCardForPotentialFraudRequestOneOf1LockTypeEnum[keyof typeof LockCardForPotentialFraudRequestOneOf1LockTypeEnum];


